import React from 'react';
import { FormattedMessage } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { Sidebar } from '@futrli/ui-components';
import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { UpdateForecastContainer } from './containers/update-forecast-container';
import { UpdateForecastContextProvider } from './context/update-forecast-context';

interface UpdateForecastSidebarProps {
  forecastId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const UpdateForecastSidebar = ({ forecastId, isOpen, onClose }: UpdateForecastSidebarProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (!forecastId) {
    return null;
  }

  return (
    <Sidebar
      header={
        <>
          <Typography variant="h2" fontWeight="700">
            <FormattedMessage id="predict.forecasting.edit_details" defaultMessage="Edit details" />
          </Typography>
        </>
      }
      onCancel={onClose}
      open={isOpen}
    >
      <UpdateForecastContextProvider key={resetKey} forecastId={forecastId}>
        <UpdateForecastContainer onClose={onClose} />
      </UpdateForecastContextProvider>
    </Sidebar>
  );
};
